/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryResolveCommentRequest
 */
export interface RevisdomAPIViewModelsEntryResolveCommentRequest {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryResolveCommentRequest
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsEntryResolveCommentRequest
     */
    isResolved?: boolean | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryResolveCommentRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryResolveCommentRequest(value: object): value is RevisdomAPIViewModelsEntryResolveCommentRequest {
    return true;
}

export function RevisdomAPIViewModelsEntryResolveCommentRequestFromJSON(json: any): RevisdomAPIViewModelsEntryResolveCommentRequest {
    return RevisdomAPIViewModelsEntryResolveCommentRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryResolveCommentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryResolveCommentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isResolved': json['isResolved'] == null ? undefined : json['isResolved'],
    };
}

export function RevisdomAPIViewModelsEntryResolveCommentRequestToJSON(json: any): RevisdomAPIViewModelsEntryResolveCommentRequest {
    return RevisdomAPIViewModelsEntryResolveCommentRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryResolveCommentRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryResolveCommentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isResolved': value['isResolved'],
    };
}

